module.exports = __webpack_public_path__ + "static/media/Christian_Inspiration_desc.2d854c67.png";